/**
 * Combines the submitted registry with the interstateThemeRegistry
 * If the registries parameter is falsy or the registries parameter is empty then return the default interstateThemeRegistry
 * @param registries
 */

const mergeRegistries = registries => {
  const effectiveRegistries = Array.isArray(registries) ? registries : [registries];
  return effectiveRegistries.length > 0 ? effectiveRegistries.reduce((prev, r) => {
    return {
      ...prev,
      ...r
    };
  }, {}) : null;
};
export default mergeRegistries;